const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export async function waitForCompleteDocument(fetchOnce, { attempts = 5, delayMs = 150, delay = sleep, initial, } = {}) {
    let last = initial;
    if (last?.ec__status === 'complete') {
        return last;
    }
    for (let attempt = 0; attempt < attempts; attempt += 1) {
        last = await fetchOnce();
        if (last?.ec__status === 'complete') {
            return last;
        }
        if (attempt < attempts - 1 && delayMs > 0) {
            await delay(delayMs);
        }
    }
    return last;
}
